module.exports = "<mat-card>\n  <div class=\"\">\n\n    <user-map *ngIf=\"init\"></user-map>\n\n  </div>\n</mat-card>\n"